import { EEnvironment } from './environment.enum';
import { IEnvironment } from './environment.interace';

export const environment: IEnvironment = {
  name: EEnvironment.DEVELOPMENT,
  apiGateway: 'https://api-dev.monitoring-life.com/api',
  emailPattern: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',

  AZURE_APP_CLIENT_ID: '78097bab-9f58-49e8-8b79-311f1c9871f9',
  AZURE_AUTHORITY: 'https://dev-myaccount.monitoring-life.com/',
  AZURE_TENANT_NAME: 'mliledevelop.onmicrosoft.com',
  AZURE_AUTHORITY_DOMAIN: 'https://dev-myaccount.monitoring-life.com',
  AZURE_REDIRECT_URI: 'https://web-dev.monitoring-life.com',
  // AZURE_REDIRECT_URI: 'http://localhost:4200',

  SIGNUP_SIGNIN_POLICY: 'B2C_1_ml_susi',
  SIGNIN_POLICY: 'B2C_1_mlsignin',
  RESET_PASSWORD_POLICY: 'B2C_1_ml_rp',
  EDIT_PROFILE_POLICY: 'B2C_1_ml_edit',
};
